import { useCallback, useEffect, useState } from 'react';

const useIsLoggedIn = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!document.querySelector('body.is-logged-in'));

  const handleEvent = useCallback(() => {
    setIsLoggedIn(!!document.querySelector('body.is-logged-in'));
  }, []);

  useEffect(() => {
    document.addEventListener('pageload-auth-synced', handleEvent);
    document.addEventListener('ds.event.userLoggedOut', handleEvent);

    return () => {
      document.removeEventListener('pageload-auth-synced', handleEvent);
      document.removeEventListener('ds.event.userLoggedOut', handleEvent);
    };
  }, []);

  return isLoggedIn;
};

export default useIsLoggedIn;